/**
 * Created by DynamicDog on 2016-12-13.
 *
 * Button in the print panel that allows the user to set the number of copies.
 * TODO: Add a delete button
 */

import {Component, Input} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
var $ = window['$'];
@Component({
    selector: 'etikett-spinner',
        template: `
            <div class="spinner {{etikettService.shape}}" >
                <div style="position:relative;">
                    <etikett class="etikett spinner-thumb clickable" [etikett]="etikett" [index]="etikett.image" [readonly]="true" (click)="onClick($event)"></etikett>
                </div>
                <div class = "clickable spinner-text" (click)="onClick($event)">
                    <div style="font-weight:bold">{{'Etikett'|translate}} {{index+1}}</div>
                    <div>{{'Antal etiketter'|translate}}</div>
                </div>
                <div class="right-area">
                <number-spinner [(counter)]='etikett.count' ngDefaultControl></number-spinner>
                <div class="spinner-delete clickable" *ngIf="etikettService.getEtiketter().length > 1" (click)="onDelete()"></div>
                </div>
            </div>
`,
})
export class EtikettSpinnerComponent {
    @Input() index:number;
    @Input() etikett: any;
    constructor(private etikettService:EtikettService) {

    }

    private onClick(event) {
        var _this = this;
        if(event.target.nodeName !== 'INPUT') {
            this.etikettService.open(this.index);
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $("#etikettHeader" + _this.index).offset().top
                }, 200);
            }, 10);
        }

    }
    private onDelete() {
        this.etikettService.removeEtikett(this.index);
    }
}


// WEBPACK FOOTER //
// ./app/print/etikettspinner.component.ts